import React from 'react';
import { AppProvider, useApp } from './context/AppContext';
import { Header } from './components/Header';
import { ScheduleView } from './components/ScheduleView';
import { ProjectsView } from './components/ProjectsView';
import { VotingView } from './components/VotingView';
import { AdminDashboard } from './components/AdminDashboard';
import { Flame, Lock } from 'lucide-react';

const MainContent: React.FC = () => {
  const { activeTab, setActiveTab, settings, isAdminAuthenticated } = useApp();

  return (
    <div className="min-h-screen bg-brand-offwhite text-brand-black flex flex-col justify-between selection:bg-brand-red selection:text-white">
      <div>
        <Header />
        <main>
          {activeTab === 'schedule' && <ScheduleView />}
          {activeTab === 'projects' && <ProjectsView />}
          {activeTab === 'vote' && <VotingView />}
          {activeTab === 'admin' && <AdminDashboard />}
        </main>
      </div>

      {/* Footer */}
      <footer className="border-t border-brand-tan py-8 pb-24 sm:pb-8 text-center text-xs text-brand-subtext bg-white/80">
        <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <Flame className="w-4 h-4 text-brand-red" />
            <span className="font-display font-bold text-brand-black">
              {settings.eventName}
            </span>
          </div>

          <div className="flex items-center gap-4 text-[11px]">
            <span>Kingdom Innovation Pitch & Grant Awards</span>
            <span className="text-brand-tan hidden xs:inline">•</span>
            <button
              onClick={() => {
                setActiveTab('admin');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-all ${
                activeTab === 'admin'
                  ? 'bg-brand-black text-white font-semibold shadow-xs'
                  : 'text-brand-subtext hover:text-brand-black hover:bg-brand-tan/30 border border-brand-tan/50'
              }`}
              title="Event Organizer Admin Dashboard"
            >
              <Lock className="w-3 h-3" />
              <span>Admin</span>
              {isAdminAuthenticated && (
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 ml-0.5" title="Logged in" />
              )}
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export const App: React.FC = () => {
  return (
    <AppProvider>
      <MainContent />
    </AppProvider>
  );
};

export default App;
